/**
 * This parsing of env variables is only used for local development for parsing FF overrides you set in the `.env.local` file.
 * In production we are not passing feature flags via env variables to the server anymore.
 */
import {FeatureToggleConfig} from './types';

// extract all env variables that start with this prefix
const FEATURE_ENV_PREFIX = 'FEATURE_';

export const extractFeatureFromEnvironment = (env = process.env) => {
  const overrides: {[key: string]: FeatureToggleConfig} = {};
  for (const [key, value] of Object.entries(env)) {
    if (key.startsWith(FEATURE_ENV_PREFIX) && value) {
      let name;
      try {
        name = key.slice(FEATURE_ENV_PREFIX.length).toLowerCase();
        overrides[name] = JSON.parse(value) as FeatureToggleConfig;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(
          '@aboutyou/feature-flags',
          `Tried to parse feature flag from environment, but received an invalid JSON string. Feature flag will be ignored. To fix this, check your environment variables for an invalid JSON.`,
          {
            featureName: name,
            environmentKey: key,
            value,
          },
        );
      }
    }
  }

  return overrides;
};
